// extracted by mini-css-extract-plugin
module.exports = {"wrap-body":"FormListInputText_wrap-body__u1y3n","wrap-input":"FormListInputText_wrap-input__GBKEI","wrap-text":"FormListInputText_wrap-text__oPHRj"};